import { type CyclesSettings, cyclesSettingsSchema } from '@xox/shared'
import { useState } from 'react'
import { Button } from '../components/ui'
import { persisted } from '../lib/storage'
import { CyclesSettingsFields } from './CyclesSettingsFields'

/** Last-used arena settings on this device. */
const cyclesSettingsStore = persisted<CyclesSettings>('cycles-settings', cyclesSettingsSchema, {
  rounds: 5,
  bots: 1,
})

interface Props {
  onCreate: (settings: CyclesSettings) => Promise<void>
  creating: boolean
  error: string | null
}

/** "Open an arena" body shared by the desktop card and the phone sheet. */
export function CyclesCreatePanel({ onCreate, creating, error }: Props) {
  const [settings, setSettings] = useState<CyclesSettings>(() => cyclesSettingsStore.load())
  const update = (patch: Partial<CyclesSettings>) => {
    const next = { ...settings, ...patch }
    setSettings(next)
    cyclesSettingsStore.save(next)
  }
  return (
    <div className="flex flex-col gap-3">
      <p className="text-sm text-slate-500">
        Up to 8 cycles, one arena. Steer, leave a wall behind you, and be the last one riding.
      </p>
      <CyclesSettingsFields value={settings} onChange={update} />
      <Button
        variant="arcade"
        tone="go"
        className="w-full"
        onClick={() => void onCreate(settings)}
        disabled={creating}
      >
        Open an arena
      </Button>
      {error && <p className="text-sm text-rose-600">{error}</p>}
    </div>
  )
}
